import { Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTypography = styled(Typography)`
    padding: 1.5rem 1.5rem 0 1.5rem;
`;

export const ClassFormContainer = styled('div')`
    width: 635px;
    padding: 0rem;
    margin: 0 auto;
    background-color: ${(props) => props.theme.palette.background.paper};
`;

export const StyledForm = styled('form')`
    display: flex;
    flex-direction: column;
`;

export const StyledFooter = styled('div')`
    display: flex;
    justify-content: flex-end;
    margin: 0.75rem;
`;

export const StyledButton = styled(Button)`
    margin-left: 0.75rem;
`;
